import React from 'react';
import CartListTable from '../cart-list/cart-list-table';

const CartPage = () => {
    return (
        <CartListTable />
        )
}

export default CartPage;